import React from 'react';

// Components
import VersionToggler from './VersionToggler';
import PermissionsToggler from './PermissionsToggler';
import LocaleToggler from './LocaleToggler';

// Utils
import { isDevDebugMode } from '@/utils/environment';

import { Typography } from '@capintel/component-lib/typography';
import { Button } from '@capintel/component-lib/button';

const DevToolPanel: React.FC = () => {
  const [open, setOpen] = React.useState(false);

  if (!isDevDebugMode()) {
    return null;
  }

  const togglePanel = () => {
    setOpen(prevOpen => !prevOpen);
  };

  return (
    <div className="dev-tool-panel">
      {open && (
        <div className="dev-tool-panel__content">
          <div className="dev-tool-panel__row">
            <PermissionsToggler closeDevToolPanel={togglePanel} />
          </div>
          <div className="dev-tool-panel__row">
            <VersionToggler closeDevToolPanel={togglePanel} />
          </div>
          <div className="dev-tool-panel__row">
            <LocaleToggler />
          </div>
          <Typography variant="bodySmRegular" color="tertiary">
            Changes won&apos;t persist.
          </Typography>
          <Typography variant="bodySmRegular" color="tertiary">
            Refresh the page to reset.
          </Typography>
        </div>
      )}
      <Button variant="secondary" aria-label="Open dev tools" onClick={togglePanel} appearance="icon" icon="settings" />
    </div>
  );
};

export default DevToolPanel;
